import React from "react";
import AnimatedCursor from "react-animated-cursor";

function Cursor() {
  return (
    <div className="cursor">
      <AnimatedCursor
        style={{ zIndex: "30000" }}
        color='0, 0, 0'
        innerSize={10}
        outerSize={40}
        outerAlpha={0.2}
        innerScale={0.7}
        outerScale={1}
        outerStyle={{
          border: '2px solid var(--light)'
        }}
        innerStyle={{
          border: '2px solid var(--light)'
        }}
      />
    </div>
  );
}

export default Cursor;
